<template>
    <template v-if="tipoUsuario === 'Administrador'">
        <NoticeAdmin></NoticeAdmin>
    </template >

    <template v-if="tipoUsuario === 'Gestor' || tipoUsuario === 'Colaborador' ">
        <NoticeGestorColab></NoticeGestorColab>
    </template >

    <template v-if="tipoUsuario === 'Supervisor'">
        <NoticeSupervisor></NoticeSupervisor>
    </template>

</template>   

<script>

import {EncryptService} from '@/services/EncryptService'
import NoticeAdmin from '@/views/notices/NoticeAdmin.vue'
import NoticeGestorColab from '@/views/notices/NoticeGestorColab.vue'
import NoticeSupervisor from '@/views/notices/NoticeSupervisor.vue'

export default {
    name: 'NoticeComponent', 
    components: {       
        NoticeAdmin,
        NoticeGestorColab,
        NoticeSupervisor
    },
    data(){
        return{
            tipoUsuario:''
        }
    },
    async beforeMount(){        
        this.tipoUsuario = await EncryptService.decrypt(localStorage.getItem('TIPO'));       
    },   
}

</script>
